import React, { useState } from "react";
import { useLocation } from "wouter";
import "./OtpVerify.css";

export default function OtpVerify() {

  const url = new URLSearchParams(window.location.search);
  const email = url.get("email");
  const regid = url.get("regid");

  // ✅ FIXED: same key used in Register.js
  const serverOtp = localStorage.getItem("otp_server");

  const [otp, setOtp] = useState("");
  const [, setLocation] = useLocation();

  function verifyOTP() {

    if (!otp.trim()) {
      alert("Enter OTP");
      return;
    }

    if (!serverOtp) {
      alert("OTP expired. Please resend OTP.");
      return;
    }

    // ✅ string comparison (safe)
    if (otp.trim() !== serverOtp.toString()) {
      alert("❌ Invalid OTP");
      return;
    }

    // ✅ OTP verified
    localStorage.removeItem("otp_server"); // prevent reuse
    alert("✅ OTP Verified Successfully 🎉");
    setLocation(`/details?email=${email}&regid=${regid}`);
  }

  return (
    <div className="otp-wrapper">
      <div id="otp-bg"></div>

      <div className="otp-card">
        <div className="head">
          <div className="spanlogin"><span>VERIFY OTP</span></div>
          <p>Email Verification - Step 2/3</p>
        </div>

        <hr/>

        <p className="sent-label">
          OTP sent to <b>{email}</b>
        </p>

        <input
          type="number"
          autoFocus
          placeholder="Enter OTP"
          value={otp}
          onChange={e => setOtp(e.target.value)}
          onKeyDown={e => e.key === "Enter" && verifyOTP()}
        />

        <button className="otpBtn" onClick={verifyOTP}>
          Verify OTP
        </button>
      </div>
    </div>
  );
}
